module.exports = __webpack_public_path__ + "static/img/activity1.d106c30a.png";